module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensedItalic-webfont.woff?9f42749fa769e93dc7f738ff960bf9d1";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensedItalic-webfont.woff
// module id = 53
// module chunks = 0